angular.module("app").constant("releaseJobStatuses", [
    {
        title: 'Preparing For Release',
        value: 10
    },
    {
        title: 'Ready For Release',
        value: 20
    },
    {
        title: 'In Progress',
        value: 30
    },
    {
        title: 'Released',
        value: 40
    },
    {
        title: 'Canceled',
        value: 50
    }
]);